import React from "react";
import { useNavigate } from "react-router-dom";

import "../../styles/news.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faUserCircle } from "@fortawesome/free-regular-svg-icons";
import classNames from "classnames";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { nav } from "framer-motion/m";

export const NewsItem = ({data}) => {

    const navigateTo = useNavigate();

    return (
        <div className="news-item">
            <img 
                src={data.image}
                alt=""
                className="news-pic" 
            />
            <div 
                className={classNames("news-type",'cons')}
                style={{backgroundColor: data.color}}
            >
                {data.category}
            </div>
            <div className="news-dets">
                <div className='news-meta'>
                    <div className="meta-unit">
                        <FontAwesomeIcon icon={faUserCircle} color="#888888" />
                        <span className='meta-text'>By: Admin</span>
                    </div>
                    <div className="meta-unit">
                        <FontAwesomeIcon icon={faCalendarAlt} color="#888888" />
                        <span className='meta-text'>12 February 2025</span>
                    </div>
                </div>
                <div className="news-cap" onClick={() => navigateTo(data.uri)}>
                    {data.title}
                </div>
                <div className="read-prompt" onClick={() => navigateTo(data.uri)}>
                    <span className="prompt-txt">Read the article</span> 
                    <FontAwesomeIcon icon={faArrowRightLong} />
                </div>
            </div>
        </div>
    );
}